import Vue from 'vue';
import { VueMaskDirective } from 'v-mask';
import money from 'v-money';
import Helpers from './helpers/helper';
Vue.directive('custom-mask', {
    bind(el, { value }) {
        if (el.classList.contains('autocomplete'))
            el = el.children[0].children[0] as HTMLInputElement;
        VueMaskDirective.bind(el, { value });

    },
    componentUpdated(el, { value, oldValue }) {
        if (el.classList.contains('autocomplete')) 
            el = el.children[0].children[0] as HTMLInputElement;

        VueMaskDirective.componentUpdated(el, { value, oldValue })
    }

})

Vue.use(money, Helpers.Money)
